export const APIErrorTypes = {
  NETWORK: "Network",
  UNKNOWN: "Unknown",
  USER: "User",
  OK: "Ok"
} 

export function buildAPIUrl(suffix) {
  return process.env.VUE_APP_BASE_API + `/api/${suffix}`
}

export function handleAPIError(vm, error) {
  const postState = {
    errorMessages: [],
    errorType: APIErrorTypes.OK,
    inProgress: false
  }

  // Set Error Details
  if (error.response) {
    const data = error.response.data

    if (data) {
      if (data.error_description) {
        // OAuth errors
        postState.errorType = APIErrorTypes.USER
        postState.errorMessages.push({message: data.error_description})

      } else if (data.modelState) {
        // Other RESTful errors
        postState.errorType = APIErrorTypes.USER
        const ignore = RegExp('^Name(.*)?is already taken.$')  // This message, generated by .Net Owin, will be ignored

        for (const property in data.modelState) {
          const keyParts = property.split('.')
          const key = keyParts[keyParts.length - 1]
          const messages = data.modelState[property]

          for (const message of messages) {
            if (ignore.test(message))
              continue

            postState.errorMessages.push({key, message})
          }
        }
      } else if (data.message) {
        postState.errorType = APIErrorTypes.USER
        postState.errorMessages.push({message: data.message})
      } else {
        postState.errorType= APIErrorTypes.UNKNOWN
        postState.errorMessages.push({message: "Unexpected Error"})
      }
    }
  } else {
    postState.errorType = APIErrorTypes.NETWORK
    postState.errorMessages.push({message: error.message})
  }

  const urlText  = error.config && error.config.url ?  `(${error.config.url})` : ""

  // For Unknown errors, tell the user that something unexpected happened
  if (postState.errorType === APIErrorTypes.UNKNOWN) {
    console.log(`Unexpected Failure${urlText}: ${error.message}`)
    vm.$bvModal.show('apiUnexpectedErrorModal')
  }

  // If network error, update global view state so we can show banner
  if (postState.errorType === APIErrorTypes.NETWORK) {
    console.log(`Network Failure${urlText}: ${error.message}`)
    vm.$store.dispatch('viewState/loadHasNetworkError',true)
  } else {
    vm.$store.dispatch('viewState/loadHasNetworkError',false)
  }

  return postState
}

export function handleGeneralFailure(error) {
  return {
    errorMessages: [{message: error}],
    errorType: APIErrorTypes.USER,
    inProgress: false
  }
}

export function resetPostState() {
  return {
    errorMessages: [],
    errorType: APIErrorTypes.OK,
    inProgress: true     
  }
}

export function handleAPISuccess(vm, response) {
  vm.$store.dispatch('viewState/loadHasNetworkError',false)

  return {
    errorMessages: [],
    errorType: APIErrorTypes.OK,
    inProgress: false     
  }
}

export function isPostError(postState) {
  return postState.errorType ? postState.errorType !== APIErrorTypes.OK : false
}